import { useQuery } from '@tanstack/react-query';

import { getChatTopics } from '~/services/SupportService';

export const chatTopicsQueryKeys = {
  all: ['chatTopics'] as const,
  list: () => [...chatTopicsQueryKeys.all, 'list'] as const,
};

export function useGetChatTopics() {
  return useQuery({
    queryKey: chatTopicsQueryKeys.list(),
    queryFn: async () => {
      const { result } = await getChatTopics();
      return result;
    },
    retry: 3,
    retryDelay: 5000,
  });
}
